import { ICertificationCode, Maybe } from 'types/FMSGraphqlTypes'
import { ICarrierCertification } from 'types/graphqlTypes'
import { TCertificationSchema } from '../schema/CertificationSchema'

export const getCertificationDefaultValues = (
  certification: Maybe<Pick<ICarrierCertification, 'code' | 'issuingOrganization' | 'renewalDate'>>
): TCertificationSchema => {
  const { code, issuingOrganization, renewalDate } = certification || {}
  return {
    code: (code as ICertificationCode) || null,
    issuingOrganization: issuingOrganization || null,
    renewalDate: renewalDate || null,
  }
}
